export interface Game {
  id: number;
  title: string;
  description: string;
  mpDescription: string;
  iconUrl: string;
  gameUrl: string;
  wideCover: string;
  key: string;
  preloader: string;
  preloaderBackground: string;
  favorite: boolean;
  sandbox: boolean;
  orientation: GameOrientation;
  showAdsOnSession: number;
  flags: {
    promoted: boolean;
    pushAllowed: boolean;
    webapp: boolean;
    noIntegration: boolean;
    bot: boolean;
    fullscreen: boolean;
    adult: boolean;
  };
  fight?: Fight;
}

export interface Fight {
  activeFrom: number;
  activeTo: number;
  me: Fighter;
  rival: Fighter;
}

interface Fighter {
  userId: number;
  avatar: string;
  name: string;
  score: number;
  reported: boolean;
}

export enum GameOrientation {
  BOTH = 'BOTH',
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export interface GameProgress {
  achievements: Achievement[];
  progress: {
    level: number;
    xp: number;
  };
}

export interface Achievement {
  name: string;
  description: string;
  points: number;
  value: number;
  additional_data: {
    [key: string | number]: any;
  };
}

export interface ScoreSuccess {
  positions: number;
  score: number;
}

export interface ErrorResponse {
  type: string;
  message: string;
  error: boolean;
}

export interface ScoreFailure {
  error: ErrorResponse;
}

export type ScoreResponse = ScoreSuccess | ScoreFailure;
